export const homeAboutUsConfigurationModel = {
  Title: "",
  Text: "",
};
